import yup, {
    cardNameValidator,
    integerPositiveValidator,
    arrayValidator,
    enumValidator,
} from '~/utils/validators.yup';

import { COMPARED_OPTIONS } from '~/config/constants';

export const schema = () =>
    yup.object({
        name: cardNameValidator(),
        characterClassId: yup.string().required(),

        damageToInflict: integerPositiveValidator,
        damageToInflictExtra: integerPositiveValidator,
        damageShield: integerPositiveValidator,

        dvAdded: integerPositiveValidator,
        dvDeducted: integerPositiveValidator,
        dvSet: integerPositiveValidator,
        dvCompareOption: enumValidator(COMPARED_OPTIONS),
        dvCompareValue: integerPositiveValidator.required().min(0).max(12),

        pointToCompare: integerPositiveValidator,
        pointToPay: integerPositiveValidator,
        pointGained: integerPositiveValidator,
        pointWon: integerPositiveValidator,
        pointLost: integerPositiveValidator,

        hpHealed: integerPositiveValidator,
        hpLost: integerPositiveValidator,
        hpCondition: integerPositiveValidator,

        numberOfExtraUpgrade: integerPositiveValidator,
        numberOfLostUpgrade: integerPositiveValidator,

        hasHalfwishRefreshed: yup.string.boolean,
        activeRounds: arrayValidator.min(1, 'at lease one round must be checked.'),
    });
